import React from 'react'
import MerchandiseBasketSummary from './basket-summary'

const MerchandiseItem = ({
  item,
  basketCounts,
  isLoading,
  hasStock
}) => {
  const merchandiseId = item.spektrix_v3_id || item.spektrix_id
  const inBasket = basketCounts[merchandiseId] || 0
  const hasHtmlDescription = item.html_description && item.html_description.trim() !== ''

  // Horizontal layout for items with HTML description
  if (hasHtmlDescription) {
    return (
      <div className='col-span-full flex flex-col sm:flex-row gap-4 rounded-lg overflow-hidden shadow-lg bg-white dark:bg-gray-800 hover:shadow-xl transition-shadow p-4'>
        {/* Image and controls on left */}
        {item.image_url && (
          <div className='flex-shrink-0 flex flex-col gap-3'>
            <img
              src={item.image_url}
              alt={item.name}
              className='w-full sm:w-48 md:w-64 aspect-square object-cover rounded-lg'
            />
            {/* Basket Controls under image */}
            <MerchandiseBasketSummary
              merchandiseId={merchandiseId}
              inBasket={inBasket}
              isLoading={isLoading}
              hasStock={hasStock}
              itemName={item.name}
            />
          </div>
        )}

        {/* Content on the right */}
        <div className='flex-1 flex flex-col'>
          {/* Title */}
          <h4 className='text-xl font-bold text-gray-900 dark:text-white mb-2'>
            {item.name}
          </h4>

          {/* Price */}
          <div className='text-lg font-semibold text-gray-900 dark:text-white mb-3'>
            £{(item.price || 0).toFixed(2)}
            {item.postage_and_packing > 0 && (
              <span className='text-sm text-gray-500 dark:text-gray-400 ml-2'>
                + £{(item.postage_and_packing || 0).toFixed(2)} P&P
              </span>
            )}
          </div>

          {/* HTML Description */}
          <div
            className='prose prose-sm dark:prose-invert max-w-none text-gray-700 dark:text-gray-300'
            dangerouslySetInnerHTML={{ __html: item.html_description }}
          />
        </div>
      </div>
    )
  }

  // Vertical card layout for simple items
  return (
    <div className='flex flex-col rounded-lg overflow-hidden shadow-lg bg-white dark:bg-gray-800 hover:shadow-xl transition-shadow'>
      {/* Item Name */}
      <div className='bg-gray-900 dark:bg-gray-950 text-xs text-white py-2 px-3 font-semibold'>
        {item.name}
      </div>

      {/* Item Image */}
      {item.image_url && (
        <img
          src={item.image_url}
          alt={item.name}
          className='w-full aspect-square object-cover'
        />
      )}

      {/* Item Details */}
      <div className='py-3 flex-1 flex flex-col'>
        <div className='text-sm text-gray-700 dark:text-gray-300 mb-3'>
          <div className='font-semibold'>£{(item.price || 0).toFixed(2)}</div>
          {item.postage_and_packing > 0 && (
            <div className='text-xs text-gray-500 dark:text-gray-400'>
              + £{(item.postage_and_packing || 0).toFixed(2)} P&P
            </div>
          )}
          {item.description && (
            <div className='text-xs text-gray-600 dark:text-gray-400 mt-2 line-clamp-2'>
              {item.description}
            </div>
          )}
        </div>

        {/* Basket Summary - full width */}
        <div className='mt-auto'>
          <MerchandiseBasketSummary
            merchandiseId={merchandiseId}
            inBasket={inBasket}
            isLoading={isLoading}
            hasStock={hasStock}
            itemName={item.name}
          />
        </div>
      </div>
    </div>
  )
}

export default MerchandiseItem
